var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28.171,28.032H0v-2H26.171V0h2Z","transform":"translate(39.742 19.822) rotate(135)","fill":"#fff"}));
}

ChevronLeft.defaultProps = {"width":"39.742","height":"39.741","viewBox":"0 0 39.742 39.741"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
